import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import IconButton from '@mui/material/IconButton';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import { createColumnDef } from 'src/components/NPIDataGrid/NPIDataGrid.utils';

export const CheckInCallSetupGridColDef = (handleEdit: (rowId: unknown) => void) => {
    return [
        createColumnDef({
            field: 'callName',
            headerName: 'Check-in Call Name',
        }),
        createColumnDef({
            field: 'callType',
            headerName: 'Check-in Type',
        }),
        createColumnDef({
            field: 'createdAt',
            headerName: 'Date Created',
        }),
        createColumnDef({
            field: 'actions',
            flex: 0,
            minWidth: 160,
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <IconButton
                        onClick={(e?: React.MouseEvent) => {
                            e?.stopPropagation?.();
                            return handleEdit(params.row);
                        }}
                        aria-label="edit"
                    >
                        <EditOutlinedIcon />
                    </IconButton>
                );
            },
        }),
    ];
};

export default CheckInCallSetupGridColDef;
